import { createContext, useContext } from 'react';

import { ArmhrNotificationOptions } from '../contexts/notification.context';

export type NotificationContextType = {
  showNotification: (options: ArmhrNotificationOptions) => void;
  isOpen: boolean;
  notification: ArmhrNotificationOptions | null;
  clearNotification: () => void;
};

export const NotificationContext = createContext<
  NotificationContextType | undefined
>(undefined);

export const useNotifications = () => {
  const context = useContext(NotificationContext);

  if (!context) {
    throw new Error(
      'useNotifications must be used within a NotificationProvider'
    );
  }

  return context;
};
